const ironboltTestimonialSwiperClass = "ironbolt-testimonial-swiper-wrapper";

const ironboltTestimonialArticleWrapper = "ironbolt-testimonial-article-wrapper";
const ironboltTestimonialArticleImgWrapper = "article-img";

const ironboltTestimonialPrevBtnClass = "ironbolt-testimonial-prev-btn";
const ironboltTestimonialNextBtnClass = "ironbolt-testimonial-next-btn";

const speed = 600;

const testimonialSwiper = initSwiperAfterLibLoad("." + ironboltTestimonialSwiperClass, {
// Optional parameters
  resistanceRatio: 0,
  parallax: false,
  direction: "horizontal",
  shortSwipes: true,
  simulateTouch: true,
  slideToClickedSlide: false,
  loop: true,
  speed: speed,
  autoHeight: true,
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
  allowSlidePrev: true,
  allowSlideNext: true,
  allowTouchMove: true,
  slidesPerView: "auto",
  // Navigation arrows
  navigation: {
    prevEl: "." + ironboltTestimonialPrevBtnClass,
    nextEl: "." + ironboltTestimonialNextBtnClass,
  },
  on: {
    init: () => {
      updateTestimonialImg(0, false);
    },
    slideChangeTransitionStart: (swiper) => {
      updateTestimonialImg(swiper.activeIndex);
    },
  },
});

function updateTestimonialImg(slideIdx, showTransition = true) {
  const activeRef = document.querySelectorAll("." + ironboltTestimonialSwiperClass + " .swiper-slide")[slideIdx].dataset.ref;
  const refImgs = Array.from(document.querySelectorAll("." + ironboltTestimonialArticleWrapper + " ." + ironboltTestimonialArticleImgWrapper));

  const activeImg = refImgs.find((img) => img.dataset.ref == activeRef);

  if (showTransition){
    refImgs.filter((img) => img != activeImg).forEach((img) => {
        img.classList.add("opacity-0");
  
        if (!img.classList.contains("d-none")) {
          img.addEventListener("transitionend", (event) => {
              img.classList.add("d-none");
              activeImg.classList.remove("d-none");
              //Waiting 2 animation frames so the d-none removal is applied to allow for the opacity transition to play
              window.requestAnimationFrame(() => {
                window.requestAnimationFrame(() => {
                  activeImg.classList.remove("opacity-0");
                });
              });
            },
            { once: true }
          );
        }
      });
  }
  else{
    activeImg.classList.remove("d-none");
    activeImg.classList.remove("opacity-0");
    refImgs.filter((img) => img != activeImg).forEach((img) => {
      img.classList.add("opacity-0");
      img.classList.add("d-none");
    });
  }
}

function selectSizeBtnClicked(btn) {
  Array.from(btn.parentElement.children).forEach((childBtn) =>
    childBtn.classList.remove("selected")
  );
  btn.classList.add("selected");
  const buyBtn = btn.closest(".styles-product").querySelector(".buy-button");
  buyBtn.classList.remove("disabled");
  buyBtn.dataset.id = btn.dataset.id;
}

function buyBtnClicked(buyBtn) {
  //If a size was selected
  if (buyBtn.dataset.id)
    window.open(`https://royer.com/products/${buyBtn.dataset.ref}?variant=${buyBtn.dataset.id}`);
  else window.open(`https://royer.com/products/${buyBtn.dataset.ref}`);
}

function shakeElement(el) {
  if (!el.classList.contains("errorShakeAnimation")) {
    el.addEventListener("animationend", () => {
      el.classList.remove("errorShakeAnimation");
    });
    el.classList.add("errorShakeAnimation");
  }
}
